import { Component } from '@angular/core';

@Component({
  selector: 'app-annule-bn-recep',
  templateUrl: './annule-bn-recep.component.html',
  styleUrls: ['./annule-bn-recep.component.scss']
})
export class AnnuleBnRecepComponent {}
